import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";

const ANN_KEYS = ["ann.1", "ann.2", "ann.3"];

function ScrollToTopOnNav() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

export default function Layout() {
  const { t, lang } = useLang();
  const settings = useSettings();
  const [annIdx, setAnnIdx] = useState(0);

  const fromSettings = lang === "nl" ? settings.announcements_nl : settings.announcements;
  const messages = (fromSettings && fromSettings.length ? fromSettings : ANN_KEYS.map((k) => t(k))).filter(Boolean);

  useEffect(() => {
    const id = setInterval(() => {
      setAnnIdx((i) => (i + 1) % Math.max(1, messages.length));
    }, 4000);
    return () => clearInterval(id);
  }, [messages.length]);

  useEffect(() => {
    const bar = document.getElementById("progress-bar");
    const back = document.getElementById("back-to-top");
    const onScroll = () => {
      const max = document.body.scrollHeight - window.innerHeight;
      if (bar) bar.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + "%";
      if (back) back.classList.toggle("visible", window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="App">
      <div id="progress-bar" role="progressbar" aria-hidden="true"></div>
      <ScrollToTopOnNav />

      <div className="reassurance" role="status" aria-live="polite" aria-label="Annonces">
        <span className="announcement-msg" key={annIdx} data-testid="announcement-bar">
          {messages[annIdx % messages.length]}
        </span>
      </div>

      <Navbar />

      <main>
        <Outlet />
      </main>

      <Footer />

      <CookieBanner />

      <button
        id="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Retour en haut de page"
        data-testid="back-to-top"
      >
        <ArrowUp size={18} />
      </button>
    </div>
  );
}
